import { DeliveryType } from "$src/domain/projects/deliveries/DeliveryType";
import { IDeliveryRepository } from "$src/domain/projects/deliveries/IDeliveryRepository";
import { ApiRoutes } from "$src/infrastructure/apiConfig/ApiRoutes";
import { BaseApi } from "$src/infrastructure/apiConfig/BaseApi";
import { injectable } from "tsyringe";

@injectable()
export class DeliveryRepositoryApi extends BaseApi implements IDeliveryRepository {
  

    protected static getRoute(groupStoreId: string, path: string) : string {
        return `${ApiRoutes.DELIVERIES.endpoint(groupStoreId)}/${path}`;
    }

    async getTypes(groupStoreId: number): Promise<DeliveryType[]> {
        try {
            const route = DeliveryRepositoryApi.getRoute(groupStoreId.toString(), 'types');

            return await this.apiClient.get<DeliveryType[]>(route);
        } catch (error) {
            console.error('Error fetching delivery types :', error);
            throw error; 
        }
    }
}